// Get All AI Training Data
export const GET_AI_TRAINING = "GET_AI_TRAINING"
export const GET_AI_TRAINING_SUCCESS = "GET_AI_TRAINING_SUCCESS"
export const GET_AI_TRAINING_FAIL = "GET_AI_TRAINING_FAIL"

// Get AI Training By ID
export const GET_AI_TRAINING_BY_ID = "GET_AI_TRAINING_BY_ID"
export const GET_AI_TRAINING_BY_ID_SUCCESS = "GET_AI_TRAINING_BY_ID_SUCCESS"
export const GET_AI_TRAINING_BY_ID_FAIL = "GET_AI_TRAINING_BY_ID_FAIL"

// Get Categories
export const GET_AI_TRAINING_CATEGORIES = "GET_AI_TRAINING_CATEGORIES"
export const GET_AI_TRAINING_CATEGORIES_SUCCESS = "GET_AI_TRAINING_CATEGORIES_SUCCESS"
export const GET_AI_TRAINING_CATEGORIES_FAIL = "GET_AI_TRAINING_CATEGORIES_FAIL"

// Upsert (Create/Update)
export const UPSERT_AI_TRAINING = "UPSERT_AI_TRAINING"
export const UPSERT_AI_TRAINING_SUCCESS = "UPSERT_AI_TRAINING_SUCCESS"
export const UPSERT_AI_TRAINING_FAIL = "UPSERT_AI_TRAINING_FAIL"

// Delete
export const DELETE_AI_TRAINING = "DELETE_AI_TRAINING"
export const DELETE_AI_TRAINING_SUCCESS = "DELETE_AI_TRAINING_SUCCESS"
export const DELETE_AI_TRAINING_FAIL = "DELETE_AI_TRAINING_FAIL"

// Reset Flag
export const RESET_AI_TRAINING_FLAG = "RESET_AI_TRAINING_FLAG"
